var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4626_14732",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4626_14732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5002 11.167H8.5002V7.33366H7.5002V11.167ZM8.0002 6.19266C8.15276 6.19266 8.28065 6.14105 8.38387 6.03783C8.48709 5.9346 8.5387 5.80671 8.5387 5.65416C8.5387 5.5016 8.48709 5.37371 8.38387 5.27049C8.28065 5.16738 8.15276 5.11583 8.0002 5.11583C7.84765 5.11583 7.71976 5.16738 7.61654 5.27049C7.51331 5.37371 7.4617 5.5016 7.4617 5.65416C7.4617 5.80671 7.51331 5.9346 7.61654 6.03783C7.71976 6.14105 7.84765 6.19266 8.0002 6.19266ZM8.00137 14.3337C7.12537 14.3337 6.30198 14.1674 5.5312 13.835C4.76043 13.5025 4.08998 13.0514 3.51987 12.4815C2.94976 11.9116 2.49837 11.2414 2.1657 10.471C1.83315 9.70055 1.66687 8.87738 1.66687 8.00149C1.66687 7.12549 1.83309 6.3021 2.16554 5.53133C2.49798 4.76055 2.94915 4.0901 3.51904 3.51999C4.08893 2.94988 4.75909 2.49849 5.52954 2.16583C6.29998 1.83327 7.12315 1.66699 7.99904 1.66699C8.87504 1.66699 9.69843 1.83321 10.4692 2.16566C11.24 2.4981 11.9104 2.94927 12.4805 3.51916C13.0506 4.08905 13.502 4.75921 13.8347 5.52966C14.1673 6.3001 14.3335 7.12327 14.3335 7.99916C14.3335 8.87516 14.1673 9.69855 13.8349 10.4693C13.5024 11.2401 13.0513 11.9105 12.4814 12.4807C11.9115 13.0508 11.2413 13.5022 10.4709 13.8348C9.70043 14.1674 8.87726 14.3337 8.00137 14.3337ZM8.0002 13.3337C9.48909 13.3337 10.7502 12.817 11.7835 11.7837C12.8169 10.7503 13.3335 9.48921 13.3335 8.00033C13.3335 6.51144 12.8169 5.25033 11.7835 4.21699C10.7502 3.18366 9.48909 2.66699 8.0002 2.66699C6.51131 2.66699 5.2502 3.18366 4.21687 4.21699C3.18354 5.25033 2.66687 6.51144 2.66687 8.00033C2.66687 9.48921 3.18354 10.7503 4.21687 11.7837C5.2502 12.817 6.51131 13.3337 8.0002 13.3337Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhite);
export default __webpack_public_path__ + "static/media/info-white.dbf08b182b6f78ac9447cdbf1204f56e.svg";
export { ForwardRef as ReactComponent };